 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"application~applicationPrinters~applicationVersion~customer~customerMaterials~fonts~industryAndCateg~949a5944":"application~applicationPrinters~applicationVersion~customer~customerMaterials~fonts~industryAndCateg~949a5944","application":"application","applicationPrinters":"applicationPrinters","applicationVersion":"applicationVersion","customer":"customer","customerMaterials":"customerMaterials","fonts":"fonts","industryAndCategory":"industryAndCategory","industryAndCategoryLanguage":"industryAndCategoryLanguage","labelFrame":"labelFrame","labelFrameCategoryLanguage":"labelFrameCategoryLanguage","labelFrameCategory~labelIconCategory":"labelFrameCategory~labelIconCategory","labelFrameCategory":"labelFrameCategory","labelIconCategory":"labelIconCategory","labelHistory":"labelHistory","labelIcon":"labelIcon","labelIconCategoryLanguage":"labelIconCategoryLanguage","material":"material","materialAttributeDef":"materialAttributeDef","materialAttributeValue":"materialAttributeValue","materialCategory":"materialCategory","materialCategoryLanguage":"materialCategoryLanguage","materialCategoryUser":"materialCategoryUser","materialType":"materialType","paperColorDef":"paperColorDef","paperTextureDef":"paperTextureDef","printer":"printer","printerCategory":"printerCategory","printerMaterials":"printerMaterials","ribbonColorDef":"ribbonColorDef","shoppingAddress":"shoppingAddress","shoppingInvoice":"shoppingInvoice","tags":"tags","templateCategoryUser":"templateCategoryUser","templatePreset":"templatePreset","templateUser":"templateUser","userList":"userList","error-page-401":"error-page-401","error-page-404":"error-page-404","profile":"profile","redirect":"redirect","userManager":"userManager"}[chunkId]||chunkId) + "." + {"application~applicationPrinters~applicationVersion~customer~customerMaterials~fonts~industryAndCateg~949a5944":"974c8407","application":"1dfdf1da","applicationPrinters":"ba894091","applicationVersion":"a1f5e0bb","customer":"5172da84","customerMaterials":"99f67c07","fonts":"7957d3bb","industryAndCategory":"36fa8469","industryAndCategoryLanguage":"4e5efc04","labelFrame":"4d0ed490","labelFrameCategoryLanguage":"8028f276","labelFrameCategory~labelIconCategory":"75c7fbab","labelFrameCategory":"7c727b56","labelIconCategory":"dbf54dfc","labelHistory":"ab9b5e1e","labelIcon":"6e2ec239","labelIconCategoryLanguage":"67307ad3","material":"305197d0","materialAttributeDef":"34b602b2","materialAttributeValue":"cdaef9ee","materialCategory":"413a8b1e","materialCategoryLanguage":"76180ff2","materialCategoryUser":"24f348ce","materialType":"a9fa368d","paperColorDef":"a8250189","paperTextureDef":"abbc847e","printer":"4dea7fb8","printerCategory":"d39604cf","printerMaterials":"eeb46b64","ribbonColorDef":"99b7f443","shoppingAddress":"8a4feab3","shoppingInvoice":"b6389c94","tags":"87dadf25","templateCategoryUser":"fca887e0","templatePreset":"3a7f40c9","templateUser":"934eecd5","userList":"4f2b206e","error-page-401":"17455287","error-page-404":"095a9e13","profile":"7c1ec2c7","redirect":"21a58702","userManager":"151d8aeb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"application~applicationPrinters~applicationVersion~customer~customerMaterials~fonts~industryAndCateg~949a5944":1,"labelFrameCategory~labelIconCategory":1,"error-page-401":1,"error-page-404":1,"profile":1,"userManager":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"application~applicationPrinters~applicationVersion~customer~customerMaterials~fonts~industryAndCateg~949a5944":"application~applicationPrinters~applicationVersion~customer~customerMaterials~fonts~industryAndCateg~949a5944","application":"application","applicationPrinters":"applicationPrinters","applicationVersion":"applicationVersion","customer":"customer","customerMaterials":"customerMaterials","fonts":"fonts","industryAndCategory":"industryAndCategory","industryAndCategoryLanguage":"industryAndCategoryLanguage","labelFrame":"labelFrame","labelFrameCategoryLanguage":"labelFrameCategoryLanguage","labelFrameCategory~labelIconCategory":"labelFrameCategory~labelIconCategory","labelFrameCategory":"labelFrameCategory","labelIconCategory":"labelIconCategory","labelHistory":"labelHistory","labelIcon":"labelIcon","labelIconCategoryLanguage":"labelIconCategoryLanguage","material":"material","materialAttributeDef":"materialAttributeDef","materialAttributeValue":"materialAttributeValue","materialCategory":"materialCategory","materialCategoryLanguage":"materialCategoryLanguage","materialCategoryUser":"materialCategoryUser","materialType":"materialType","paperColorDef":"paperColorDef","paperTextureDef":"paperTextureDef","printer":"printer","printerCategory":"printerCategory","printerMaterials":"printerMaterials","ribbonColorDef":"ribbonColorDef","shoppingAddress":"shoppingAddress","shoppingInvoice":"shoppingInvoice","tags":"tags","templateCategoryUser":"templateCategoryUser","templatePreset":"templatePreset","templateUser":"templateUser","userList":"userList","error-page-401":"error-page-401","error-page-404":"error-page-404","profile":"profile","redirect":"redirect","userManager":"userManager"}[chunkId]||chunkId) + "." + {"application~applicationPrinters~applicationVersion~customer~customerMaterials~fonts~industryAndCateg~949a5944":"5b6491a4","application":"31d6cfe0","applicationPrinters":"31d6cfe0","applicationVersion":"31d6cfe0","customer":"31d6cfe0","customerMaterials":"31d6cfe0","fonts":"31d6cfe0","industryAndCategory":"31d6cfe0","industryAndCategoryLanguage":"31d6cfe0","labelFrame":"31d6cfe0","labelFrameCategoryLanguage":"31d6cfe0","labelFrameCategory~labelIconCategory":"a72ecf4b","labelFrameCategory":"31d6cfe0","labelIconCategory":"31d6cfe0","labelHistory":"31d6cfe0","labelIcon":"31d6cfe0","labelIconCategoryLanguage":"31d6cfe0","material":"31d6cfe0","materialAttributeDef":"31d6cfe0","materialAttributeValue":"31d6cfe0","materialCategory":"31d6cfe0","materialCategoryLanguage":"31d6cfe0","materialCategoryUser":"31d6cfe0","materialType":"31d6cfe0","paperColorDef":"31d6cfe0","paperTextureDef":"31d6cfe0","printer":"31d6cfe0","printerCategory":"31d6cfe0","printerMaterials":"31d6cfe0","ribbonColorDef":"31d6cfe0","shoppingAddress":"31d6cfe0","shoppingInvoice":"31d6cfe0","tags":"31d6cfe0","templateCategoryUser":"31d6cfe0","templatePreset":"31d6cfe0","templateUser":"31d6cfe0","userList":"31d6cfe0","error-page-401":"c14269e3","error-page-404":"0701e1da","profile":"a1c311a4","redirect":"31d6cfe0","userManager":"353b4538"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
